var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Page',{attrs:{"selectedPageTemplate":_vm.templateName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }